// extracted by mini-css-extract-plugin
export default {"space":"InputWindow_space__0BBQy","active":"InputWindow_active__GoaqG","container":"InputWindow_container__vKIWN","btn":"InputWindow_btn__o6+jx"};